import request from "api/axiosClient";

export const getGraphicalStatisticsRevenueReport = async (values) => {
    const result = await request({
        url: "revenue-report/graphical-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}
export const getDataStatisticsRevenueReport = async (values) => {
    const result = await request({
        url: "revenue-report/data-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}

export const _exportHistory = async (values) => {

    const response = await request({
        url: `revenue-report/export-history`,
        method: 'POST',
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/json',
        },
        data: values,
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));

    const a = document.createElement('a');
    a.href = url;
    a.download = 'output.xlsx'; // Tên file muốn lưu
    document.body.appendChild(a);
    a.click();
    a.remove(); // Sau khi tải về, xóa element a khỏi DOM
}